import PropTypes from 'prop-types';
// @mui
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Autocomplete, Card } from '@mui/material';
import TextField from '@mui/material/TextField';

// ----------------------------------------------------------------------

const groupLabel = (integrated) =>
  integrated ? 'Com integração Wialon' : 'Sem integração';

const toOption = (item) => ({
  label: item.name,
  value: item,
  integrated: Boolean(item.wialon_id),
});

export default function LogisticsSelectCorporation({
  corporations,
  selectedCorporationId,
  setSelectedCorporationId,
}) {
  const handleSelectCorporation = (data) => {
    const id = data?.value?.id ?? null;
    setSelectedCorporationId(id);
    // Remember the last chosen corporation as the default for future sessions.
    if (id != null) {
      localStorage.setItem('main_corporation_id', id);
    }
  };

  const selectedCorporation =
    corporations?.find((c) => c.id === selectedCorporationId) ?? null;

  // Wialon-integrated corporations first, then the rest; alpha by code within
  // each group (copy — never sort the SWR array in place).
  const options = [...(corporations || [])].map(toOption).sort((a, b) => {
    if (a.integrated !== b.integrated) return a.integrated ? -1 : 1;
    return (a.value.code || '').localeCompare(b.value.code || '');
  });

  return (
    <Card
      sx={{
        p: 2,
        borderRadius: 2,
        boxShadow: '0 0 5px rgba(0, 0, 0, 0.01), 0 5px 5px rgba(0, 0, 0, 0.02)',
      }}
    >
      <Stack
        spacing={2}
        direction={{ xs: 'column', md: 'row' }}
        alignItems={{ xs: 'stretch', md: 'center' }}
      >
        <Typography variant="subtitle1" sx={{ flexShrink: 0 }}>
          Corporação
        </Typography>
        <Autocomplete
          fullWidth
          options={options}
          groupBy={(option) => groupLabel(option.integrated)}
          isOptionEqualToValue={(option, val) => option.value.id === val.value.id}
          onChange={(_, data) => handleSelectCorporation(data)}
          value={selectedCorporation ? toOption(selectedCorporation) : null}
          sx={{
            backgroundColor: 'background.neutral',
            borderRadius: 1,
          }}
          renderInput={(params) => (
            <TextField {...params} label="Selecione a corporação" />
          )}
        />
      </Stack>
    </Card>
  );
}

LogisticsSelectCorporation.propTypes = {
  corporations: PropTypes.array,
  selectedCorporationId: PropTypes.number,
  setSelectedCorporationId: PropTypes.func,
};
